// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"223":"commons","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"223":"8f1d2b20319067382366","245":"f99dcb32ae4417310479","453":"df0c801d3b69e6dbaf5c","522":"005cd8f34ea9ba848c2f"}[chunkId] + ".js";
};